import cn from 'bem-cn';

import prompthubEllipse from '../../../images/icons/prompthub-ellipse.svg';

import { Avatar, Icon, Link, Stack } from '../../UI';
import { pluralize } from '../../../utils/pluralize/pluralize';
import { getUserProfileLink } from '../../../utils/url';

import { PromptInfoAuthorProps } from './PromptInfoAuthor.types';
import './PromptInfoAuthor.scss';

const b = cn('prompt-info-author');

export const PromptInfoAuthor = ({ author, subtitle, disabled }: PromptInfoAuthorProps) => {
    const { image, name, promptsCount, publicId, isPublic, isEditor } = author;
    const authorImage = isEditor ? prompthubEllipse : image;

    const plural =
        promptsCount &&
        pluralize(promptsCount, {
            one: 'промпт',
            few: 'промпта',
            many: 'промптов',
        });

    const authorProfileLink = publicId ? getUserProfileLink(publicId) : undefined;

    const renderContent = () => {
        return (
            <Stack direction="row" justifyContent="space-between" spacing={8} py={12} px={16} className={b('content')}>
                <Stack direction="row" alignItems="center" spacing={12}>
                    <Avatar image={authorImage} size="medium" />
                    <Stack>
                        <p className={b('small-text', { secondary: true })}>{subtitle}</p>
                        <p className={b('name')}>{name}</p>
                    </Stack>
                </Stack>
                <Stack direction="row" spacing={8} alignItems="center">
                    {Boolean(promptsCount) && <p className={b('small-text')}>{plural}</p>}
                    {authorProfileLink && isPublic && <Icon name="chevronRight" size={18} />}
                </Stack>
            </Stack>
        );
    };

    if (authorProfileLink && isPublic) {
        return (
            <Link to={authorProfileLink} className={b('clickable', { disabled })}>
                {renderContent()}
            </Link>
        );
    }

    return <div className={b({ disabled })}>{renderContent()}</div>;
};
